import { FormEvent } from "react";
import "../stylesheets/loginForm.scss";
import { authenticate, AuthenticationResponse } from "../services/api";
import { isAuthenticated } from "../services/utils";
import { useNotification } from "../contexts/NotificationContext";

// TYPES

// COMPONENT

function LoginForm() {
	const { notify } = useNotification();
	const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const formData = new FormData(e.currentTarget);
		const mail = formData.get("mail") as string;
		const password = formData.get("password") as string;
		const response = await authenticate(mail, password);
		if (response) {
			sessionStorage.setItem(
				"authenticationToken",
				response.authenticationToken,
			);
			sessionStorage.setItem("refreshToken", response.refreshToken);
			sessionStorage.setItem("role", response.role);
			sessionStorage.setItem("mail", response.email);
			//window.location.reload();
			notify({
				type: "validation",
				title: "Connecté avec succès",
				subtitle: "en tant que " + response.role,
			});
		} else {
			notify({
				type: "error",
				title: "Connexion refusée",
				subtitle: "Mot de passe ou email invalide",
			});
		}
	};
	const logout = () => {
		sessionStorage.removeItem("authenticationToken");
		sessionStorage.removeItem("refreshToken");
		sessionStorage.removeItem("role");
		sessionStorage.removeItem("mail");
		window.location.reload();
	};
	return (
		<>
			{!isAuthenticated() ? (
				<form className="login-form" onSubmit={(e) => handleSubmit(e)}>
					<h2>Se Connecter</h2>
					<input
						type="text"
						name="mail"
						placeholder="jean.dupont@gmail.com"
						required
					/>
					<input
						type="password"
						name="password"
						placeholder="password"
						required
					/>
					<button type="submit">login</button>
				</form>
			) : (
				<form className="login-form" onSubmit={() => logout()}>
					<h2>Se Déconnecter</h2>
					<span className="primary-text">
						{sessionStorage.getItem("mail")}
					</span>
					<span className="primary-text">
						{sessionStorage.getItem("role")}
					</span>
					<button type="submit">logout</button>
				</form>
			)}
		</>
	);
}

export default LoginForm;
